import { useScrollReveal } from '@/hooks/useScrollReveal';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '多重内容审核',
    desc: '每条内容经过编辑团队三重核实与 AI 辅助审核，杜绝虚假爆料，确保信息真实可靠，打造值得信赖的正能量黑料平台。',
    color: 'primary',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '正能量独家定位',
    desc: '专注积极向上的黑料内容，筛选有温度、有深度、有正能量的爆料故事，重新定义黑料行业标准，让每一次浏览都收获启发。',
    color: 'accent',
  },
  {
    icon: 'ri-group-line',
    title: '活跃优质社区',
    desc: '汇聚众多正能量读者，评论区域理性友善，鼓励真诚分享与有深度的互动讨论，构建高质量的内容交流生态空间。',
    color: 'secondary',
  },
  {
    icon: 'ri-rocket-line',
    title: '每日高频更新',
    desc: '保持每日 50+ 条精选内容的更新频率，覆盖八大话题领域，每周推出新专题合集，确保读者每天都有新鲜的正能量内容。',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; iconBg: string; iconColor: string; badge: string; badgeText: string }> = {
  primary: { bg: 'hover:border-primary-300', iconBg: 'bg-primary-100 group-hover:bg-primary-200', iconColor: 'text-primary-600', badge: 'bg-primary-100/70', badgeText: 'text-primary-700' },
  accent: { bg: 'hover:border-accent-300', iconBg: 'bg-accent-100 group-hover:bg-accent-200', iconColor: 'text-accent-600', badge: 'bg-accent-100/70', badgeText: 'text-accent-700' },
  secondary: { bg: 'hover:border-secondary-300', iconBg: 'bg-secondary-100 group-hover:bg-secondary-200', iconColor: 'text-secondary-600', badge: 'bg-secondary-100/70', badgeText: 'text-secondary-700' },
};

export default function FeaturesSection() {
  const { ref, isVisible } = useScrollReveal(0.15);

  return (
    <section id="features" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/60 px-3 py-1 rounded-full mb-3">
            核心优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            四大核心优势，重新定义黑料内容平台的价值标准与体验高度
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {features.map((f, i) => {
            const c = colorMap[f.color];
            return (
              <div
                key={i}
                className={`bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7 text-center group transition-all cursor-default ${c.bg}`}
              >
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5 transition-colors ${c.iconBg}`}>
                  <i className={`${f.icon} text-2xl ${c.iconColor}`}></i>
                </div>
                <div className={`inline-block text-xs px-2.5 py-1 rounded-full mb-3 ${c.badge} ${c.badgeText}`}>
                  {['审核体系', '内容定位', '社区生态', '运营节奏'][i]}
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2.5">
                  {f.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}